import React, { useState } from 'react';
import api from '../api/client';

export default function SubscribeForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await api.post('/api/public/subscribe', { email });
      setStatus('done');
      setMessage('확인 메일을 발송했습니다. 이메일을 확인해 구독을 완료해 주세요.');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || '구독 신청 중 오류가 발생했습니다.');
    }
  };

  if (status === 'done') {
    return (
      <div className="subscribe-box success">
        <p>{message}</p>
      </div>
    );
  }

  return (
    <div className="subscribe-box">
      <p>새 글을 이메일로 받아보세요.</p>
      <form onSubmit={handleSubmit} className="subscribe-form">
        <input
          type="email"
          placeholder="이메일 주소"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? '처리 중...' : '구독하기'}
        </button>
      </form>
      {status === 'error' && <p className="error-msg">{message}</p>}
    </div>
  );
}
